interface Names {
  fullName?: string;
  firstName?: string;
  lastName?: string;
}

export const extractNamesByFullName = (fullName: string | undefined): Names => {
  const [firstName, lastName] = fullName?.split(/\s+(.*)/) || [];
  return {
    fullName: fullName || '',
    firstName: firstName || '',
    lastName: lastName || '',
  };
};

// o POCKET manda "null null" / "undefined" quando a conta não tem nome
export const sanitizeDisplayName = (name: string | undefined | null): string => {
  if (!name) return '';

  return name
    .split(/\s+/)
    .filter(part => part && !/^(null|undefined)$/i.test(part))
    .join(' ')
    .trim();
};
